'use strict';

const BaseView = require('components-framework/view/base.view');
const withRenderedMain = require('components-framework/view/with_rendered_main');
const withCachedSelectors = require('components-framework/view/with_cached_selectors');
const trackingUtils = require('od-modules/utils/tracking.utils');
const tagManagement = require('od-modules/utils/tag_management.utils');

const TRACKING = require('./trackingConstants');
const tripDetailsAfDpFactory = require('./tripdetails_afdp_factory');
const appSplashOverlay = require('./app_splash_overlay');
const appLandingUrl = require('./appLandingUrl');

const DEFAULT_DATA = {
    openTicketPNRs: {},
    trackingParams: {},
    renderPNRCards: true,
};
const SURVEY_EVENT_ACCEPT = 'ticketAccept';
const SURVEY_EVENT_REJECT = 'ticketReject';

module.exports = withRenderedMain(withCachedSelectors(BaseView.extend({
    templateSettings: {
        evaluate: /\{\{#([\s\S]+?)\}\}/g,
        interpolate: /\{\{[^#{]([\s\S]+?)[^}]\}\}/g,
        escape: /\{\{\{([\s\S]+?)\}\}\}/g,
    },

    incidentsManagerWidget: null,

    selectors: {
        changedSections: '.changed_sections',
        termsAndConditionsLinkBox: '.terms_and_conditions_link_box',
        acceptanceOverlay: '.open_ticket_acceptance_overlay',
        acceptedOverlay: '.open_ticket_accepted_overlay',
        openTicketCustomerSupportOverlay: '.customer_support_overlay',
        openTicketDownloadAppCustomerSupport: '.download_app_customer_support',
        cashRefundOverlay: '.cash_refund_overlay',
        cashRefundTitle1: '.cash_refund_title1',
        cashRefundTitle2: '.cash_refund_title2',
        acceptedOpenTicketsWrapper: '.accepted_opentickets_wrapper',
        pendingOpenTicketsWrapper: '.pending_opentickets_wrapper',
        rejectedOpenTicketsWrapper: '.rejected_opentickets_wrapper',
        redemptionPendingOpenTicketsWrapper: '.redemption_pending_opentickets_wrapper',
        acceptedPNRCards: '.accepted_pnr_cards',
        pendingPNRCards: '.pending_pnr_cards',
        rejectedPNRCards: '.rejected_pnr_cards',
        redemptionPendingPNRCards: '.redemption_pending_pnr_cards',
        accordionItem: '.accordion_item',
        acceptedSectionsContainer: '.accepted_sections_container',
        manageFlexibleTicketBtn: '.manage_flexible_ticket_click',
        termsConditionsB: '.terms_conditions_b',
        acceptedOptionsPrime: '.accepted_options_prime',
    },

    events: {
        'tap .terms_and_conditions_link_click': 'termsAndConditionsLinkOpen',
        'tap .terms_and_conditions_link_close': 'termsAndConditionsLinkClose',
        'tap .manage_flexible_ticket_click': 'managePendingFlexibleTicket',
        'tap .manage_flexible_ticket_close': 'closeAcceptanceOverlay',
        'tap .accept_flexible_ticket_click': 'acceptFlexibleTicketButtonClick',
        'tap .openticket_accordion_section': 'onClickAccordionSection',
        'tap .manage_accepted_overlay_close': 'closeAcceptedOverlay',
        'tap .available_flights_button_click': 'openTicketSeeAvailableFlightsClick',
        'tap .manage_accepted_overlay_open': 'manageAcceptedFlexibleTicket',
        'tap .get_the_app_overlay_open > span': 'openRedemptionPendingAppOverlayEvent',
        'tap .get_the_app_overlay_close, .get_the_app_overlay': 'closeGetTheAppOverlay',
        'tap .customer_support_close': 'customerSupportClose',
        'tap .customer_support_cta_call': 'customerSupportCtaCall',
        'tap .customer_support_cta_back': 'customerSupportCtaBack',
        'tap .customer_support_inside_click': 'customerSupportOverlayClick',
        'tap .customer_support_cta': 'customerSupportCta',
        'tap .customer_support_app_cta': 'customerSupportAppCta',
        'tap .app_store_btn': 'openAppStoreBtn',
        'tap .popup_inside_click': 'popupOverlayClick',
        'tap .manage_redeemed_pnr_click': 'onManageRedeemedPNRBtnClick',
        'tap .show_cash_refund_click': 'showCashRefundClick',
        'tap .show_cash_refund_back_click': 'showCashRefundBackClick',
        'tap .cash_refund_close': 'cashRefundClose',
        'tap .accept_credit_flexibleticket_click': 'acceptCreditFlexibleTicketClick',
        'tap .request_refund_flexibleTicket_click': 'requestRefundFlexibleTicketClick',
        'tap .keep_credit_flexibleticket_click': 'keepCreditFlexibleTicketClick',
        'tap .regret_accepting_credit': 'regretAcceptingCredit',
        'tap .cash_refund_inside_click': 'cashRefundOverlayClick',
        'tap .close_terms_conditions_b': 'onCloseTermsConditionsB',
        'tap .credit_tc_link': 'onOpenTermsConditionsB',
        'tap .accept_flexible_ticket_footer': 'acceptCreditFromAcceptanceFooter',
        'tap .close_overlay': 'closeOverlay',
        'tap .close_overlay_background': 'closeOverlayBackground',
        'tap .rejected_pnr_info_block > span': 'openRefundDeferredLink',
        'tap .open_app_splash_link_button': 'openAppSplashLinkButton',
        'tap .open_app_splash_link_phone': 'openAppSplashLinkPhone',
        'tap .accepted_options_prime_btn': 'onAcceptedOptionsPrimeBtn',
        'tap .cant_download_app_link': 'cantDownloadAppLinkClick',
        'tap .open_app_splash_overlay': 'openAppSplashOverlayEvent',
    },

    CSS_CLASSES: {
        ODF_HIDDEN: 'odf-hidden',
        OD_ACCORDION_UNCOLLAPSED: 'od-accordion-uncollapsed',
        OD_NO_Z_INDEX: 'od-no-z-index',
        OD_OVERFLOW: 'od-overflow',
        OPENED: 'open opened',
    },

    TRACKING,

    initialize(data) {
        Odigeo._.defaultsDeep(data, DEFAULT_DATA);
        this.openTicketRepository = data.openTicketRepository;
        this.parentWidget = data.parentWidget;
        this.appSplashOverlay = appSplashOverlay.factory(this, data.bookingInfo);
        const {openTicketPNRs, bookingId, buyerName, buyerMail, bookingCreationDate} = data;
        this.model.set({
            openTicketPNRs,
            bookingId,
            buyerName,
            buyerMail,
            renderPNRCards: data.options.renderPNRCards,
            bookingCreationDate,
            bookingInfo: data.bookingInfo,
        });
        this.setTrackingInfo(data.trackingInfo);

        if (!Odigeo._.isEmpty(this.model.get('openTicketPNRs'))) {
            this.bindPNRStatusChanges();
            this.model.set('acceptedPNRs', data.acceptedPNRs);
            this.model.set('pendingPNRs', data.pendingPNRs);
            this.model.set('rejectedPNRs', data.rejectedPNRs);
            this.model.set('redemptionPendingPNRs', data.redemptionPendingPNRs);
        }
        this.updateDomSelectorsToCache();
        this.onTrackingOnload();
    },

    bindPNRStatusChanges() {
        this.listenTo(this.model, 'change:acceptedPNRs', this.renderAcceptedPNRs);
        this.listenTo(this.model, 'change:pendingPNRs', this.renderPendingPNRs);
        this.listenTo(this.model, 'change:rejectedPNRs', this.renderRejectedPNRs);
        this.listenTo(this.model, 'change:redemptionPendingPNRs', this.renderRedemptionPendingPNRs);
    },

    renderAcceptedPNRs() {
        const acceptedPNRs = this.model.get('acceptedPNRs');
        const shouldHideWrapper = (acceptedPNRs.length) === 0;
        this.pnrCardsRenderHelper(this.$cachedSelectors.acceptedPNRCards, this.templates.acceptedPnrCard, acceptedPNRs);
        this.$cachedSelectors.acceptedOpenTicketsWrapper.toggleClass(this.CSS_CLASSES.ODF_HIDDEN, shouldHideWrapper);
        if (this.isShowFlightCreditInLocation()) {
            const firstAcceptedPNR = acceptedPNRs[0];
            this.openAcceptedOverlay(firstAcceptedPNR);
        }
    },

    renderPendingPNRs() {
        const pendingPNRs = this.model.get('pendingPNRs');
        const shouldHideWrapper = (pendingPNRs.length) === 0;
        this.pnrCardsRenderHelper(this.$cachedSelectors.pendingPNRCards, this.templates.pendingPnrCard, pendingPNRs);
        this.$cachedSelectors.pendingOpenTicketsWrapper.toggleClass(this.CSS_CLASSES.ODF_HIDDEN, shouldHideWrapper);
        if (pendingPNRs.length > 0) {
            const firstPendingPNR = pendingPNRs[0];
            this.openAcceptanceOverlay(firstPendingPNR);
            Odigeo.trigger(this.name + ':showFlightStatusMessage');
        } else {
            Odigeo.trigger(this.name + ':hideFlightStatusMessage');
        }
    },

    renderRejectedPNRs() {
        const rejectedPNRs = this.model.get('rejectedPNRs');
        const shouldHideWrapper = (rejectedPNRs.length === 0);
        this.pnrCardsRenderHelper(this.$cachedSelectors.rejectedPNRCards, this.templates.rejectedPnrCard, rejectedPNRs);
        this.$cachedSelectors.rejectedOpenTicketsWrapper.toggleClass(this.CSS_CLASSES.ODF_HIDDEN, shouldHideWrapper);

        if (rejectedPNRs.length > 0) {
            const params = this.model.get('trackingParams');
            const eventClickRejected = this.TRACKING.LOAD_OPENTIKCET_REJECTED.EVENT;
            this.TRACKING.LOAD_OPENTIKCET_REJECTED.PNR = params.totalPnrsInBooking;
            this.trackEventWithParams(eventClickRejected, this.TRACKING.TRACKING_PARAMS, {flex: this.getTrackingPNRStatus()});
        }
    },

    renderRedemptionPendingPNRs() {
        const redemptionPendingPNRs = this.model.get('redemptionPendingPNRs');
        const shouldHideWrapper = (redemptionPendingPNRs.length === 0);
        this.pnrCardsRenderHelper(this.$cachedSelectors.redemptionPendingPNRCards, this.templates.redemptionPendingPnrCard, redemptionPendingPNRs);
        this.$cachedSelectors.redemptionPendingOpenTicketsWrapper.toggleClass(this.CSS_CLASSES.ODF_HIDDEN, shouldHideWrapper);
    },

    pnrCardsRenderHelper($containerElement, template, pnrlist) {
        const pnrsToRender = Odigeo._.pick(this.model.get('openTicketPNRs'), pnrlist);
        const cardsRendered = Odigeo._.reduce(pnrsToRender, (cardsRendered, pnrInfo, pnr) => {
            const templateData = this.extendTemplateData(pnrInfo);
            templateData.pnr = pnr;
            cardsRendered.push(template(templateData));
            return cardsRendered;
        }, []);
        $containerElement.html(cardsRendered);
        this.updateDomSelectorsToCache();
    },

    extendTemplateData(data) {
        const additionalData = {
            keys: this.keys,
            templates: this.templates,
            imagePath: Odigeo.UserArea.imagePath,
            brandedImagePath: Odigeo.UserArea.brandedImagePath,
            humanTripDate: Odigeo._.partial(Odigeo.Utils.formatDate, _, _, true),
            bookingId: this.model.get('bookingId'),
            replaceCmsKeyArgs: Odigeo.Utils.replaceCmsKeyArgs,
            buyerName: Odigeo.Utils.capitalize(this.model.get('buyerName')),
            buyerMail: this.model.get('buyerMail'),
            bookingCreationDate: this.model.get('bookingCreationDate'),
            isIOS: Odigeo.Device.navigator.isIOS,
            isAndroid: Odigeo.Device.navigator.isAndroid,
            renderPNRCards: this.model.get('renderPNRCards'),
        };
        return Object.assign(data, additionalData);
    },

    get$ElementsWithMatchingPNRAttr($elementsList, pnr) {
        return $elementsList.filter((i, domEl) => domEl.dataset.openticketPnr === pnr);
    },

    termsAndConditionsLinkOpen(event) {
        const $currentTarget = $(event.currentTarget);
        const trackEvent = $currentTarget.attr('data-openticket-trackevent').toUpperCase();
        let customTrackingParams = {};

        $(event.target).parent().siblings(this.selectors.termsAndConditionsLinkBox).toggleClass(this.CSS_CLASSES.OPENED, true);
        this.TRACKING[trackEvent].PNR = $currentTarget.attr('data-openticket-pnr');
        if (this.TRACKING[trackEvent].PAG) {
            customTrackingParams = {pag: this.TRACKING[trackEvent].PAG};
        }

        this.trackEventWithData(this.TRACKING[trackEvent].EVENT, customTrackingParams);
    },

    termsAndConditionsLinkClose(event) {
        this.$cachedSelectors.termsAndConditionsLinkBox.toggleClass(this.CSS_CLASSES.OPENED, false);
    },

    // PENDING PNR CARD
    managePendingFlexibleTicket(event) {
        event.stopPropagation();
        const pnr = Odigeo._.get(event, 'currentTarget.dataset.openticketPnr');
        this.trackOpenAcceptanceOverlay(pnr);
        this.openAcceptanceOverlay(pnr);
    },

    openAcceptanceOverlay(pnr) {
        if (this.model.get('confirmationLayerShown') === true) {
            this.model.set('confirmationLayerShown', false);
        }
        this.get$ElementsWithMatchingPNRAttr(this.$cachedSelectors.acceptanceOverlay, pnr).toggleClass(this.CSS_CLASSES.OPENED, true);
        trackingUtils.trackPage(this.TRACKING.TRACKING_PAGE.ACCEPTANCE, {
            funnel: false,
        });
    },

    trackOpenAcceptanceOverlay(pnr) {
        this.TRACKING.OPEN.PNR = pnr;
        this.trackEventWithData(this.TRACKING.OPEN.EVENT);
    },

    closeAcceptanceOverlay(event) {
        event.stopPropagation();
        const pnr = Odigeo._.get(event, 'currentTarget.dataset.openticketPnr');
        this.$cachedSelectors.acceptanceOverlay.toggleClass(this.CSS_CLASSES.OPENED, false);
        this.TRACKING.CLOSE_ACCEPTANCE.PNR = pnr;
        this.trackEventWithData(this.TRACKING.CLOSE_ACCEPTANCE.EVENT);
    },

    // ACCEPTED PNR CARD
    manageAcceptedFlexibleTicket(event) {
        event.stopPropagation();
        const pnr = Odigeo._.get(event, 'currentTarget.dataset.openticketPnr');
        this.trackOpenAcceptedOverlay(pnr);
        this.openAcceptedOverlay(pnr);
    },

    trackOpenAcceptedOverlay(pnr) {
        this.TRACKING.OPEN_ACCEPTED_MANAGE_BUTTON.PNR = pnr;
        this.trackEventWithData(this.TRACKING.OPEN_ACCEPTED_MANAGE_BUTTON.EVENT);
    },

    openAcceptedOverlay(pnr) {
        this.get$ElementsWithMatchingPNRAttr(this.$cachedSelectors.acceptedOverlay, pnr).toggleClass(this.CSS_CLASSES.OPENED, true);
        trackingUtils.trackPage(this.TRACKING.TRACKING_PAGE.ACCEPTED, {
            funnel: false,
        });
        this.showAcceptedOptionsPrime(pnr);
    },

    closeAcceptedOverlay(event) {
        event.stopPropagation();
        event.preventDefault();
        const pnr = Odigeo._.get(event, 'currentTarget.dataset.openticketPnr');
        this.$cachedSelectors.acceptedOverlay.toggleClass(this.CSS_CLASSES.OPENED, false);
        this.TRACKING.CLOSE_ACCEPTED.PNR = pnr;
        const customTrackingParams = {pag: this.TRACKING.PAGE.ACCEPTED_LAYER};
        this.trackEventWithData(this.TRACKING.CLOSE_ACCEPTED.EVENT, customTrackingParams);
        if (this.isShowFlightCreditInLocation()) {
            window.history.pushState({}, document.title, window.location.href.replace('showFlightCredit=true', ''));
        }
    },

    isShowFlightCreditInLocation() {
        return window.location.hash.includes('showFlightCredit=true');
    },

    // REDEMPTION PENDING PNR CARD
    openRedemptionPendingAppOverlayEvent(event) {
        event.stopPropagation();
        const pnr = Odigeo._.get(event, 'target.dataset.openticketPnr');
        this.openRedemptionPendingAppOverlay(pnr);
    },

    openRedemptionPendingAppOverlay(pnr) {
        this.appSplashOverlay.open(appSplashOverlay.versions.processingRedemption, this.model.get('openTicketPNRs')[pnr]);
    },

    requestRefundFlexibleTicketClick(event) {
        event.stopPropagation();
        const pnr = Odigeo._.get(event, 'currentTarget.dataset.openticketPnr');
        const customTrackingParams = {};
        const customTrackingSplashParams = {
            pag: this.TRACKING.PAGE.ACCEPTANCE_CRL,
        };
        this.TRACKING.CASH_REFUND_REQUEST_REFUND.PNR = pnr;
        this.trackEventWithData(this.TRACKING.CASH_REFUND_REQUEST_REFUND.EVENT, customTrackingParams);
        this.rejectFlexibleTicket(pnr, customTrackingSplashParams);
    },

    regretAcceptingCredit(event) {
        event.stopPropagation();
        const pnr = Odigeo._.get(event, 'currentTarget.dataset.openticketPnr');
        const customTrackingParams = {
            pag: this.TRACKING.PAGE.ACCEPTED_LAYER,
        };
        const customTrackingSplashParams = {
            pag: this.TRACKING.PAGE.ACCEPTED_CRL,
        };
        this.TRACKING.CASH_REFUND_REQUEST_REFUND.PNR = pnr;
        this.trackEventWithData(this.TRACKING.CASH_REFUND_REQUEST_REFUND.EVENT, customTrackingParams);
        this.rejectFlexibleTicket(pnr, customTrackingSplashParams);
    },

    rejectFlexibleTicket(pnr, customTrackingSplashParams = {}) {
        this.parentWidget.rejectOpenTicket(pnr);
        this.model.rejectOpenTicket(pnr);
        this.addSurveyExtraData(pnr);
        if (Odigeo.Utils.isMobile()) {
            this.showRejectedAppSplashOverlay(pnr, customTrackingSplashParams);
        } else {
            this.externalSurvey(SURVEY_EVENT_REJECT);
        }
    },

    showRejectedAppSplashOverlay(pnr, customTrackingSplashParams = {}) {
        this.TRACKING.APP_SPLASH_LOAD_REJECT.PNR = pnr;
        this.trackEventWithData(this.TRACKING.APP_SPLASH_LOAD_REJECT.EVENT, customTrackingSplashParams);
        this.appSplashOverlay.open(appSplashOverlay.versions.rejected, this.model.get('openTicketPNRs')[pnr]);
    },

    // Accepting Flexible tickets
    acceptFlexibleTicketButtonClick(event) { // New acceptance page credit option section
        event.stopPropagation();
        const pnr = Odigeo._.get(event, 'currentTarget.dataset.openticketPnr');
        const customTrackingParams = {};
        this.TRACKING.ACCEPT.PNR = pnr;
        this.trackEventWithData(this.TRACKING.ACCEPT.EVENT, customTrackingParams);
        this.acceptFlexibleTicket(pnr);
    },

    acceptCreditFromAcceptanceFooter(event) {
        event.stopPropagation();
        const pnr = Odigeo._.get(event, 'currentTarget.dataset.openticketPnr');
        const customTrackingParams = {};
        this.TRACKING.ACCEPT_FROM_FOOTER.PNR = pnr;
        this.trackEventWithData(this.TRACKING.ACCEPT_FROM_FOOTER.EVENT, customTrackingParams);
        this.acceptFlexibleTicket(pnr);
    },

    acceptCreditFlexibleTicketClick(event) { // New acceptange page inside CRL credit section.
        event.stopPropagation();
        const pnr = Odigeo._.get(event, 'currentTarget.dataset.openticketPnr');
        const customTrackingParams = {};
        const customTrackingSplashParams = {pag: this.TRACKING.PAGE.ACCEPTANCE_CRL};
        this.TRACKING.CASH_REFUND_KEEP_ACCEPT_CREDIT.PNR = pnr;
        this.trackEventWithData(this.TRACKING.CASH_REFUND_KEEP_ACCEPT_CREDIT.EVENT, customTrackingParams);
        this.acceptFlexibleTicket(pnr, customTrackingSplashParams);
    },

    acceptFlexibleTicket(pnr, customTrackingSplashParams = {}) {
        this.parentWidget.acceptOpenTicket(pnr);
        this.model.acceptOpenTicket(pnr);
        this.openAcceptedOverlay(pnr);
        this.addSurveyExtraData(pnr);
        if (Odigeo.Utils.isMobile()) {
            this.showAcceptedAppSplashOverlay(pnr, customTrackingSplashParams);
        } else {
            this.externalSurvey(SURVEY_EVENT_ACCEPT);
        }
    },

    showAcceptedAppSplashOverlay(pnr, customTrackingSplashParams = {}) {
        this.TRACKING.APP_SPLASH_LOAD_ACCEPT.PNR = pnr;
        this.trackEventWithData(this.TRACKING.APP_SPLASH_LOAD_ACCEPT.EVENT, customTrackingSplashParams);
        this.appSplashOverlay.open(appSplashOverlay.versions.accepted, this.model.get('openTicketPNRs')[pnr]);
    },

    keepCreditFlexibleTicketClick(event) {
        event.stopPropagation();
        const pnr = Odigeo._.get(event, 'currentTarget.dataset.openticketPnr');
        const customTrackingParams = {
            pag: this.TRACKING.PAGE.ACCEPTED_LAYER,
        };
        this.$cachedSelectors.cashRefundOverlay.toggleClass(this.CSS_CLASSES.OPENED, false);
        this.TRACKING.CASH_REFUND_KEEP_ACCEPT_CREDIT.PNR = pnr;
        this.trackEventWithData(this.TRACKING.CASH_REFUND_KEEP_ACCEPT_CREDIT.EVENT, customTrackingParams);
    },

    onClickAccordionSection(event) {
        const $currentTarget = $(event.currentTarget);

        $currentTarget.parents(this.selectors.accordionItem).toggleClass(this.CSS_CLASSES.OD_ACCORDION_UNCOLLAPSED);
        const trackingEvent = this.TRACKING.ACCORDION[$currentTarget.attr('data-openticket-accordion-label')];
        let customTrackingParams = {};

        if ($currentTarget.attr('data-openticket-overlay') === 'accepted') {
            customTrackingParams.pag = this.TRACKING.PAGE.ACCEPTED_LAYER;
        }
        this.TRACKING[trackingEvent].PNR = $currentTarget.attr('data-openticket-pnr');
        this.trackEventWithData(this.TRACKING[trackingEvent].EVENT, customTrackingParams);
    },

    openTicketSeeAvailableFlightsClick(event) {
        const $currentTarget = $(event.currentTarget);
        const bookingId = this.model.get('bookingId');
        const pnr = $currentTarget.attr('data-openticket-pnr');
        const bookingItemId = this.model.get('openTicketPNRs')[pnr].sections[0].itineraryBookingId;
        $currentTarget.addClass('loading').attr('disabled', true);
        this.openTicketRepository.getRedemptionConditions({bookingId, bookingItemId}).then((redemptionConditions) => {
            if (redemptionConditions.inScope && Odigeo.Utils.isMobile()) {
                this.redirectToRedemptionFlow(pnr, redemptionConditions);
            } else if (redemptionConditions.inScope && Odigeo.SessionScope.brand !== 'TL') {
                this.appSplashOverlay.open(appSplashOverlay.versions.redemptionFlow, this.model.get('openTicketPNRs')[pnr]);
            } else {
                $(event.target)
                    .closest(this.selectors.acceptedOverlay + '[data-openticket-pnr="' + pnr + '"]')
                    .find(this.selectors.openTicketCustomerSupportOverlay).toggleClass(this.CSS_CLASSES.OPENED, true);
                trackingUtils.trackPage(this.TRACKING.TRACKING_PAGE.CUSTOMER_SUPPORT, {
                    funnel: false,
                });
            }
        }).finally(() => {
            $currentTarget.removeClass('loading').attr('disabled', false);
        });


        const customTrackingParams = {pag: this.TRACKING.PAGE.ACCEPTED_LAYER};
        this.TRACKING.SEE_AVAILABLE_FLIGHTS.PNR = pnr;
        this.trackEventWithData(this.TRACKING.SEE_AVAILABLE_FLIGHTS.EVENT, customTrackingParams);
    },

    redirectToRedemptionFlow(pnr, redemptionConditions) {
        Odigeo.trigger(`${this.name}:redirectToOpenTicketFlow`, {
            pnr,
            pnrData: this.model.get('openTicketPNRs')[pnr],
            redemptionConditions,
        });
    },

    customerSupportClose(event) {
        const $currentTarget = $(event.currentTarget);
        const openTicketCustomerSupportOverlay = $currentTarget.parents(this.selectors.openTicketCustomerSupportOverlay);
        const pnr = openTicketCustomerSupportOverlay.attr('data-openticket-pnr');

        openTicketCustomerSupportOverlay.toggleClass(this.CSS_CLASSES.OPENED, false);

        this.TRACKING.CLOSE_CUSTOMER_SUPPORT.PNR = pnr;
        this.trackingCommonCustomerSupportClose(event);

        event.stopPropagation();
    },

    closeOverlayBackground(e) {
        const $currentTarget = $(e.currentTarget);

        if ($currentTarget[0] === $(e.target)[0]) {
            this.appSplashOverlay.close();
            this.appSplashOverlay.trackCloseBackground(e);
            e.stopPropagation();
        }
    },

    closeOverlay(e) {
        const $currentTarget = $(e.currentTarget);

        if ($currentTarget[0] === $(e.target)[0]) {
            this.appSplashOverlay.close();
            this.appSplashOverlay.trackClose(e);
            e.stopPropagation();
        }
    },

    customerSupportOverlayClick(event) {
        const $currentTarget = $(event.currentTarget);
        const pnr = $currentTarget.attr('data-openticket-pnr');

        if ($currentTarget[0] === $(event.target)[0]) {
            $currentTarget.toggleClass(this.CSS_CLASSES.OPENED, false);

            this.TRACKING.CLOSE_CUSTOMER_SUPPORT.PNR = pnr;
            this.trackingCommonCustomerSupportClose(event);
        }
    },

    trackingCommonCustomerSupportClose(event) {
        const customTrackingParams = {pag: this.TRACKING.PAGE.CUSTOMER_SUPPORT_LAYER};
        this.trackEventWithData(this.TRACKING.CLOSE_CUSTOMER_SUPPORT.EVENT, customTrackingParams);
    },

    customerSupportCtaCall(event) {
        location.href = this.$(event.currentTarget).attr('data-openticket-phonenumber');

        $(event.currentTarget).parents(this.selectors.acceptedOverlay).toggleClass(this.CSS_CLASSES.OPENED, false);
        $(event.currentTarget).parents(this.selectors.openTicketCustomerSupportOverlay).toggleClass(this.CSS_CLASSES.OPENED, false);

        const customTrackingParams = {pag: this.TRACKING.PAGE.CUSTOMER_SUPPORT_LAYER};
        const openTicketCustomerSupportOverlay = this.$(event.currentTarget).parents(this.selectors.openTicketCustomerSupportOverlay);
        this.TRACKING.CUSTOMER_SUPPORT_CTA_CALL.PNR = openTicketCustomerSupportOverlay.attr('data-openticket-pnr');
        this.trackEventWithData(this.TRACKING.CUSTOMER_SUPPORT_CTA_CALL.EVENT, customTrackingParams);

        event.stopPropagation();
    },

    customerSupportCtaBack(event) {
        $(event.currentTarget).parents(this.selectors.acceptedOverlay).toggleClass(this.CSS_CLASSES.OPENED, false);
        $(event.currentTarget).parents(this.selectors.openTicketCustomerSupportOverlay).toggleClass(this.CSS_CLASSES.OPENED, false);

        const customTrackingParams = {pag: this.TRACKING.PAGE.CUSTOMER_SUPPORT_LAYER};
        const openTicketCustomerSupportOverlay = this.$(event.currentTarget).parents(this.selectors.openTicketCustomerSupportOverlay);
        this.TRACKING.CUSTOMER_SUPPORT_CTA_BACK.PNR = openTicketCustomerSupportOverlay.attr('data-openticket-pnr');
        this.trackEventWithData(this.TRACKING.CUSTOMER_SUPPORT_CTA_BACK.EVENT, customTrackingParams);

        event.stopPropagation();
    },


    customerSupportCta(event) {
        const $currentTarget = $(event.currentTarget);
        const openTicketCustomerSupportOverlay = $currentTarget.parents(this.selectors.openTicketCustomerSupportOverlay);
        const pnr = openTicketCustomerSupportOverlay.attr('data-openticket-pnr');

        openTicketCustomerSupportOverlay.toggleClass(this.CSS_CLASSES.OPENED, false);

        this.TRACKING.CUSTOMER_SUPPORT_CTA_CALL.PNR = pnr;
        const customTrackingParams = {pag: this.TRACKING.PAGE.CUSTOMER_SUPPORT_LAYER};
        this.trackEventWithData(this.TRACKING.CUSTOMER_SUPPORT_CTA_CALL.EVENT, customTrackingParams);

        event.stopPropagation();
    },

    customerSupportAppCta(event) {
        const $currentTarget = $(event.currentTarget);
        const pnr = $currentTarget.attr('data-openticket-pnr');
        const {brandNewNomenclature, locale, website} = Odigeo.SessionScope;
        const landingUrl = appLandingUrl({
            brandNewNomenclature,
            locale,
            website,
        });
        window.open(landingUrl, '_blank');

        this.TRACKING.APP_SPLASH_DOWNLOAD_DESKTOP.PNR = pnr;
        this.trackEventWithData(this.TRACKING.APP_SPLASH_DOWNLOAD_DESKTOP.EVENT, {
            pag: this.TRACKING.PAGE.CUSTOMER_SUPPORT_LAYER,
        });
        event.stopPropagation();
    },

    openAppStoreBtn(event) {
        const url = this.$(event.currentTarget).attr('data-openapp-url');
        this.TRACKING.OPEN_MOBILE_APP.PNR = this.$(event.currentTarget).attr('data-openticket-pnr');
        const customTrackingParams = {pag: this.TRACKING.PAGE.ACCEPTED_LAYER};
        this.trackEventWithData(this.TRACKING.OPEN_MOBILE_APP.EVENT, customTrackingParams);
        window.open(url);
    },

    popupOverlayClick(event) {
        const $currentTarget = $(event.currentTarget);

        if ($currentTarget[0] === $(event.target)[0]) {
            $currentTarget.toggleClass(this.CSS_CLASSES.OPENED, false);
        }
    },

    openRefundDeferredLink() {
        this.trackEventWithData(this.TRACKING.GET_APP.EVENT);
        this._openDeferredDeepLink(this.keys.deferredLinkTD);
    },

    openAppSplashLinkButton(event) {
        const $currentTarget = $(event.currentTarget);
        const version = $currentTarget.attr('data-splash-version');
        const pnr = $currentTarget.attr('data-openticket-pnr');
        const isFromNotificationManager = $currentTarget.attr('data-notification-scope');
        const customTrackingParams = {
            pag: this.TRACKING.PAGE.ACCEPTED_LAYER,
        };
        const notificationManagerRefund = isFromNotificationManager === 'true' && version === 'refund';
        const appSplashDeferredLink = notificationManagerRefund ? this.keys.notificationCashRefundDeferredLink : this.keys.appSplashDeferredLink;

        if (version === 'accepted') {
            this.TRACKING.DOWNLOAD_APP_SPLASH_ACCEPT_BUTTON.PNR = pnr;
            this.trackEventWithData(this.TRACKING.DOWNLOAD_APP_SPLASH_ACCEPT_BUTTON.EVENT, customTrackingParams);
        } else if (version === 'rejected') {
            this.TRACKING.DOWNLOAD_APP_SPLASH_REJECT_BUTTON.PNR = pnr;
            this.trackEventWithData(this.TRACKING.DOWNLOAD_APP_SPLASH_REJECT_BUTTON.EVENT, customTrackingParams);
        } else if (version === 'refund') {
            this.TRACKING.DOWNLOAD_APP_SPLASH_REFUND_BUTTON.PNR = pnr;
            this.trackEventWithData(this.TRACKING.DOWNLOAD_APP_SPLASH_REFUND_BUTTON.EVENT);
        }

        this._openDeferredDeepLink(appSplashDeferredLink);
        this.appSplashOverlay.close();
    },

    openAppSplashLinkPhone(event) {
        const $currentTarget = $(event.currentTarget);
        const version = $currentTarget.attr('data-splash-version');
        const pnr = $currentTarget.attr('data-openticket-pnr');
        const isFromNotificationManager = $currentTarget.attr('data-notification-scope');
        const customTrackingParams = {
            pag: this.TRACKING.PAGE.ACCEPTED_LAYER,
        };
        const notificationManagerRefund = isFromNotificationManager === 'true' && version === 'refund';
        const appSplashDeferredLink = notificationManagerRefund ? this.keys.notificationCashRefundDeferredLink : this.keys.appSplashDeferredLink;

        if (version === 'accepted') {
            this.TRACKING.DOWNLOAD_APP_SPLASH_ACCEPT_PHONE.PNR = pnr;
            this.trackEventWithData(this.TRACKING.DOWNLOAD_APP_SPLASH_ACCEPT_PHONE.EVENT, customTrackingParams);
        } else if (version === 'rejected') {
            this.TRACKING.DOWNLOAD_APP_SPLASH_REJECT_PHONE.PNR = pnr;
            this.trackEventWithData(this.TRACKING.DOWNLOAD_APP_SPLASH_REJECT_PHONE.EVENT, customTrackingParams);
        } else if (version === 'refund') {
            this.TRACKING.DOWNLOAD_APP_SPLASH_REFUND_PHONE.PNR = pnr;
            this.trackEventWithData(this.TRACKING.DOWNLOAD_APP_SPLASH_REFUND_PHONE.EVENT);
        }

        this._openDeferredDeepLink(appSplashDeferredLink);
        this.appSplashOverlay.close();
    },

    _openDeferredDeepLink(link) {
        const bookingId = this.model.get('bookingId');
        const email = this.model.get('buyerMail');
        const brand = Odigeo.SessionScope.brand;
        let afDpParam = tripDetailsAfDpFactory.tripDetailsAfDpFactory({brand, bookingId, email});
        const deferredLink = Odigeo.Utils.replaceCmsKeyArgs(link, afDpParam);

        window.open(deferredLink);
    },

    openAppSplashOverlayEvent(event) {
        const $currentTarget = $(event.currentTarget);
        const pnr = $currentTarget.attr('data-openticket-pnr');
        this.TRACKING.OPEN_APP_SPLASH_CLICK_BUTTON.PNR = pnr;
        this.trackEventWithData(this.TRACKING.OPEN_APP_SPLASH_CLICK_BUTTON.EVENT);
        this.openAppSplashOverlay(pnr);
    },

    openAppSplashOverlay(pnr, notificationManagerScope) {
        if (Odigeo.Utils.isMobile()) {
            this.appSplashOverlay.open(appSplashOverlay.versions.refund, this.model.get('openTicketPNRs')[pnr], 50, notificationManagerScope);
        } else {
            this.appSplashOverlay.open(appSplashOverlay.versions.refund, this.model.get('openTicketPNRs')[pnr], 0, notificationManagerScope);
        }
    },

    showCashRefundClick(event) {
        event.stopPropagation();
        const $currentTarget = $(event.currentTarget);
        const shouldShowConfirmationLayer = (!this.model.get('confirmationLayerShown') || !$currentTarget.attr('data-openticket-backarrow'));
        const pnr = $currentTarget.attr('data-openticket-pnr');
        let customTrackingParams = {};
        let pagePath;

        this.TRACKING.REFUND.PNR = pnr;
        if ($currentTarget.attr('data-openticket-overlay') === 'accepted' || $currentTarget.attr('data-openticket-overlay') === 'acceptance_b') {
            customTrackingParams.pag = this.TRACKING.PAGE.ACCEPTED_LAYER;
        }
        this.trackEventWithData(this.TRACKING.REFUND.EVENT, customTrackingParams);

        if (shouldShowConfirmationLayer) {
            if ($currentTarget.attr('data-openticket-backarrow') === true) {
                this.model.set('confirmationLayerShown', true);
            }

            this.$cachedSelectors.cashRefundTitle1.filter('[data-openticket-pnr="' + pnr + '"]').toggleClass(this.CSS_CLASSES.ODF_HIDDEN, false);
            this.$cachedSelectors.cashRefundTitle2.filter('[data-openticket-pnr="' + pnr + '"]').toggleClass(this.CSS_CLASSES.ODF_HIDDEN, true);
            this.$cachedSelectors.cashRefundOverlay.filter('[data-openticket-pnr="' + pnr + '"]').toggleClass(this.CSS_CLASSES.OPENED, true);

            this.TRACKING.CASH_REFUND_LOAD.PNR = pnr;
            if ($currentTarget.attr('data-openticket-overlay') === 'accepted') {
                pagePath = this.TRACKING.TRACKING_PAGE.CASH_REFUND_ACCEPTED;
            } else {
                pagePath = this.TRACKING.TRACKING_PAGE.CASH_REFUND_ACCEPTANCE;
            }

            trackingUtils.trackPage(pagePath, {
                funnel: false,
            });

            this.trackEventWithData(this.TRACKING.CASH_REFUND_LOAD.EVENT, customTrackingParams);
        } else {
            this.closeAcceptanceOverlay(event);
        }
    },

    showCashRefundBackClick(event) {
        const $currentTarget = $(event.currentTarget);
        const shouldShowConfirmationLayer = (!this.model.get('confirmationLayerShown'));

        if (shouldShowConfirmationLayer) {
            this.model.set('confirmationLayerShown', true);

            const pnr = $currentTarget.attr('data-openticket-pnr');

            this.$cachedSelectors.cashRefundTitle1.filter('[data-openticket-pnr="' + pnr + '"]').toggleClass(this.CSS_CLASSES.ODF_HIDDEN, true);
            this.$cachedSelectors.cashRefundTitle2.filter('[data-openticket-pnr="' + pnr + '"]').toggleClass(this.CSS_CLASSES.ODF_HIDDEN, false);
            this.$cachedSelectors.cashRefundOverlay.filter('[data-openticket-pnr="' + pnr + '"]').toggleClass(this.CSS_CLASSES.OPENED, true);

            trackingUtils.trackPage(this.TRACKING.TRACKING_PAGE.CASH_REFUND_ACCEPTANCE, {
                funnel: false,
            });

            this.TRACKING.CASH_REFUND_LOAD_BACK.PNR = pnr;
            this.trackEventWithData(this.TRACKING.CASH_REFUND_LOAD_BACK.EVENT);
        } else {
            this.closeAcceptanceOverlay(event);
        }
    },

    cashRefundClose(event) {
        const $currentTarget = $(event.currentTarget);
        const cashRefundOverlay = $currentTarget.parents(this.selectors.cashRefundOverlay);

        cashRefundOverlay.toggleClass(this.CSS_CLASSES.OPENED, false);

        this.trackingCommonCashRefundClose(event);

        event.stopPropagation();
    },

    cashRefundOverlayClick(event) {
        const $currentTarget = $(event.currentTarget);

        if ($currentTarget[0] === $(event.target)[0]) {
            $currentTarget.toggleClass(this.CSS_CLASSES.OPENED, false);
        }

        this.trackingCommonCashRefundClose(event);
    },

    trackingCommonCashRefundClose(event) {
        const $currentTarget = $(event.currentTarget);
        const pnr = $currentTarget.attr('data-openticket-pnr');
        let customTrackingParams = {};

        if ($currentTarget.attr('data-openticket-overlay') === 'accepted') {
            customTrackingParams.pag = this.TRACKING.PAGE.ACCEPTED_LAYER;
        }

        this.TRACKING.CASH_REFUND_CLOSE.PNR = pnr;
        this.trackEventWithData(this.TRACKING.CASH_REFUND_CLOSE.EVENT, customTrackingParams);
    },

    onManageRedeemedPNRBtnClick(event) {
        const $currentTarget = $(event.currentTarget);
        const pnr = $currentTarget.attr('data-openticket-pnr');
        this.redirectToRedemptionFlow(pnr);
    },

    onOpenTermsConditionsB(event) {
        const $currentTarget = $(event.currentTarget);
        const pnr = $currentTarget.attr('data-openticket-pnr');
        let customTrackingParams = {};

        customTrackingParams.pag = this.TRACKING.PAGE.ACCEPTED_LAYER;

        this.TRACKING.OPEN_CREDIT_TCS.PNR = pnr;
        this.trackEventWithData(this.TRACKING.OPEN_CREDIT_TCS.EVENT, customTrackingParams);

        this.TRACKING.OPEN_CREDIT_TCS_LOAD.PNR = pnr;
        this.trackEventWithData(this.TRACKING.OPEN_CREDIT_TCS_LOAD.EVENT, customTrackingParams);

        $(this.selectors.termsConditionsB).addClass('open');
    },

    onCloseTermsConditionsB(event) {
        const $currentTarget = $(event.currentTarget);
        const pnr = $currentTarget.attr('data-openticket-pnr');
        let customTrackingParams = {};

        customTrackingParams.pag = this.TRACKING.PAGE.ACCEPTED_LAYER;

        this.TRACKING.CLOSE_CREDIT_TCS.PNR = pnr;
        this.trackEventWithData(this.TRACKING.CLOSE_CREDIT_TCS.EVENT, customTrackingParams);

        $(this.selectors.termsConditionsB).removeClass('open');
    },

    cantDownloadAppLinkClick(event) {
        const $currentTarget = $(event.currentTarget);
        const pnr = $currentTarget.attr('data-openticket-pnr');
        event.target.parentElement
            .querySelector(this.selectors.openTicketDownloadAppCustomerSupport).classList
            .remove(this.CSS_CLASSES.ODF_HIDDEN);
        event.stopPropagation();

        this.TRACKING.APP_SPLASH_NA_DESKTOP.PNR = pnr;
        this.trackEventWithData(this.TRACKING.APP_SPLASH_NA_DESKTOP.EVENT, {
            pag: this.TRACKING.PAGE.CUSTOMER_SUPPORT_LAYER,
        });
    },

    setTrackingInfo(trackingInfo) {
        const customParams = {
            sce: 'REFUND',
            prov: 'GDS',
        };
        this.model.set('trackingParams', Object.assign({}, trackingInfo, customParams));
    },

    getTrackingLabelPrefix(event) {
        const params = this.model.get('trackingParams');

        if (event === 'GET_APP') {
            return `booking:${params.totalSections}-${params.totalPnrsInBooking}_${this.TRACKING[event].PARTIAL}`;
        } else {
            return `booking:${params.totalSections}-${this.TRACKING[event].PNR}_${this.TRACKING[event].PARTIAL}`;
        }
    },

    onTrackingOnload() {
        const params = this.model.get('trackingParams');
        this.TRACKING.ONLOAD.PNR = params.totalPnrsInBooking;
        this.trackEventWithParams(this.TRACKING.ONLOAD.EVENT, this.TRACKING.TRACKING_PARAMS, {flex: this.getTrackingPNRStatus()});
    },

    getTrackingPNRStatus(pnr) {
        const acceptedPNRs = this.model.get('acceptedPNRs');
        const pendingPNRs = this.model.get('pendingPNRs');
        const rejectedPNRs = this.model.get('rejectedPNRs');
        const allPNRs = {acceptedPNRs, pendingPNRs, rejectedPNRs};
        const isFlexiblePNRs = (acceptedPNRs.length > 0) || (pendingPNRs.length > 0) || (rejectedPNRs.length > 0);
        let pnrStatus = 'NA';
        if (isFlexiblePNRs) {
            pnrStatus = pnr ? this.getFlexibleTicketStatusSingle(allPNRs, pnr) : this.getFlexibleTicketStatusGrouped(allPNRs);
        }
        return pnrStatus;
    },

    getFlexibleTicketStatusGrouped(allPNRs) {
        const keys = Object.keys(allPNRs);
        let groupedStatus = keys.map((key) => allPNRs[key].map(() => {
            return this.TRACKING.FLEXIBLE_STATUS[key];
        }));
        return groupedStatus.flat().join('-');
    },

    getFlexibleTicketStatusSingle(allPNRs, pnr) {
        const singleStatus = Object.keys(allPNRs).filter((e) => allPNRs[e].includes(pnr)).join();
        return this.TRACKING.FLEXIBLE_STATUS[singleStatus];
    },

    trackEventWithData(event, customTrackingInfo = {}, paramNames = this.TRACKING.TRACKING_PARAMS) {
        customTrackingInfo.flex = this.getTrackingPNRStatus(this.TRACKING[event].PNR);
        let paramNamesList = paramNames.slice();
        this.trackEventWithParams(event, paramNamesList, customTrackingInfo);
    },

    trackEventWithParams(event, paramNames, customTrackingInfo = {}) {
        const trackingInfo = Object.assign({}, this.model.get('trackingParams'), customTrackingInfo);
        const prefix = this.getTrackingLabelPrefix(event);

        const label = paramNames.reduce((acc, paramName) => {
            return `${acc}_${paramName}:${trackingInfo[paramName]}`;
        }, prefix);
        trackingUtils.trackEvent(this.TRACKING[event].ACTION, label);
    },

    addSurveyExtraData(pnr) {
        this.$el.find('.survey_extra_data').attr('data-survey-pnr-selected', '');
        this.$el.find(`.survey_extra_data[data-pnr="${pnr}"]`).attr('data-survey-pnr-selected', 'selected');
    },

    externalSurvey(surveyEvent) {
        tagManagement.fireExternalEvent('qualtrics', surveyEvent);
    },

    showAcceptedOptionsPrime(pnr) {
        const isPrimeUser = this.parentWidget.getIsPrimeUser();
        const isValidPrimeSubscriptionAmount = this.model.get('openTicketPNRs')[pnr].primeSubscriptionAmount !== '';
        const isPostBookingPageC = Odigeo.Membership.membershipPostBookingPage === 3;
        const data = {
            keys: this.keys,
            replaceCmsKeyArgs: Odigeo.Utils.replaceCmsKeyArgs,
            primeSubscriptionAmount: this.model.get('openTicketPNRs')[pnr].primeSubscriptionAmount,
        };
        const primeExpirationDate = this.parentWidget.getPrimeExpirationDate();
        const todayPlusSevenDays = Odigeo.Utils.addDays(Odigeo.Utils.getToday(), 7);
        const isValidPrimeExpirationDate = !!(primeExpirationDate && primeExpirationDate > todayPlusSevenDays);

        if (isPrimeUser && isValidPrimeExpirationDate && isValidPrimeSubscriptionAmount) {
            this.$cachedSelectors.acceptedOptionsPrime.html(this.templates.usersPrime(data));
            this.TRACKING.OPTIONS_PRIME_LOAD.PNR = pnr;
            const customTrackingParams = {pag: this.TRACKING.OPTIONS_PRIME_LOAD.PAG};
            this.trackEventWithData(this.TRACKING.OPTIONS_PRIME_LOAD.EVENT, customTrackingParams);
        } else if (!isPrimeUser && Odigeo.Membership.isMembershipProductEnabled &&
            isPostBookingPageC && isValidPrimeSubscriptionAmount) {
            this.$cachedSelectors.acceptedOptionsPrime.html(this.templates.usersNonPrime(data));
            this.TRACKING.OPTIONS_NON_PRIME_LOAD.PNR = pnr;
            const customTrackingParams = {pag: this.TRACKING.OPTIONS_NON_PRIME_LOAD.PAG};
            this.trackEventWithData(this.TRACKING.OPTIONS_NON_PRIME_LOAD.EVENT, customTrackingParams);
        }
    },

    onAcceptedOptionsPrimeBtn(e) {
        this.TRACKING.ACCEPTED_OPTIONS_PRIME_BTN.PNR = $(e.currentTarget).attr('data-openticket-pnr');
        const customTrackingParams = {pag: this.TRACKING.ACCEPTED_OPTIONS_PRIME_BTN.PAG};
        this.trackEventWithData(this.TRACKING.ACCEPTED_OPTIONS_PRIME_BTN.EVENT, customTrackingParams);
        Odigeo.Router.navigate('primepostbooking');
    },
})));
